export default __webpack_public_path__ + "8d345839d84606887b6767b5b8ff88a1.woff2";